import {FilterInterface} from './filter-interface';
import {FilterSearch} from '../../../filter-search';

export class Filter extends FilterSearch implements FilterInterface {

  count: number;

  constructor(attrs: { childFacetList?: any, field?: string, value?: string, selected?: boolean, excluded?: boolean, or?: boolean, count?: number, range?: boolean, hideInResult?: boolean } = {}) {
    super(attrs);
    this.update(attrs);
  }

  update(attr: { childFacetList?: any, field?: string, value?: string, selected?: boolean, excluded?: boolean, or?: boolean, count?: number, range?: boolean, hideInResult?: boolean } = {}) {
    super.update(attr);
    this.count = attr.count;
  }

}
